import { render, staticRenderFns } from "./TrainingsCarousel.vue?vue&type=template&id=284b8958&scoped=true"
import script from "./TrainingsCarousel.vue?vue&type=script&lang=js"
export * from "./TrainingsCarousel.vue?vue&type=script&lang=js"
import style0 from "./TrainingsCarousel.vue?vue&type=style&index=0&id=284b8958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b8958",
  null
  
)

export default component.exports